<template>
  <b-form-group
    :id="id + '-group'"
    :label="label"
    :label-for="id"
    :state="!errors.has(id)"
    :invalid-feedback="errors.first(id)"
    class="form-selectbox-icons"
  >
    <multiselect
      ref="formSelectboxIcons"
      v-model="model"
      :class="{ 'is-invalid': errors.has(id) }"
      :name="'select-' + id"
      :options="options"
      :searchable="false"
      :show-labels="false"
      :placeholder="placeholder"
      :disabled="disabled"
      :data-testing="dataTesting"
      track-by="value"
      label="label"
      @input="onChangeModel"
    >
      <template
        slot="option"
        slot-scope="{ option }"
      >
        <span
          :class="'form-selectbox-icons__icon--' + option.locale"
          class="form-selectbox-icons__icon"
          v-html="option.label"
        />
      </template>
    </multiselect>
    <input
      :id="id"
      ref="formSelectboxIconsHidden"
      v-validate="{ rules: validationRules }"
      :name="id"
      :value="hiddenValue"
      type="hidden"
      data-vv-validate-on="change"
    >
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { BFormGroup } from 'bootstrap-vue';

/**
* Form Selectbox with Validation
*/
export default {
  name: 'FormSelectboxIcons',
  components: {
    Multiselect,
    BFormGroup
  },
  inject: {
    $validator: '$validator'
  },
  props: {
    /**
    * selectbox id - it's used also as name attribute for the hidden input field and for error handling
    */
    id: {
      type: String,
      default: ''
    },
    /**
    * label for the bootstrap form group
    */
    label: {
      type: String,
      default: ''
    },
    /**
    * placeholder for multiselect
    */
    placeholder: {
      type: String,
      default: ''
    },
    /**
    * required attribute
    */
    required: {
      type: Boolean,
      default: false
    },
    /**
    * value to fill in data from the api
    */
    value: {
      type: Number,
      default: null
    },

    /**
     * Options to set by the api
     */
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    /**
     * disable selectbox
    */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Variable for cypress testing
     */
    dataTesting: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      /**
      * @model
      */
      model: null
    };
  },
  computed: {
    validationRules() {
      return {
        required: this.required
      };
    },
    hiddenValue(){
      return (this.model) ? this.model.value : '';
    }
  },
  watch: {
    // detect changes in store step data
    value(newVal) {
      this.createModel(newVal);
    }
  },
  mounted() {
    const vm = this;
    this.$nextTick(() => vm.createModel(this.value));
  },
  methods: {
    /**
    * update model and validate hidden field - this is a special case for vue-multiselect
    * @event onChangeModel
    * @type {Input}
    */
    onChangeModel(value) {
      this.model = value;
      this.$emit('onchange', { key: this.id, val: value });

      if (this.required) {
        this.$validator.validate(
          this.id,
          this.model ? this.model : null
        );
      }
    },
    /**
    * create model from current value
    * @event createModel
    * @param {number} val - current value
    */
    createModel(val) {
      if (this.value && this.value !== null && typeof this.options[0] === 'object') {
        this.model = this.options.find((o) => o.value === val);
      }
    }
  }
};
</script>

<style lang="scss">
  @import '~vue-multiselect/dist/vue-multiselect.min.css';
  @import './../../styles/multiselect';
  @import './FormSelectboxIcons';
</style>
